import type { IEnglishIqItemV2 } from '@repo/sdk';
import type { EnglishIqV2ClientItemType } from '../english-iq-v2-stored-flow';

export function toEnglishIqV2ClientItem(item: IEnglishIqItemV2): EnglishIqV2ClientItemType {
  return { ...item, renderer: item.type };
}
